import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { APIS } from '../../common/constants';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OrdersService {
  constructor(
    private httpService: HttpService
  ) {
  }

  getOrders(query: Record<string, any>): Observable<any> {
    return this.httpService.getData(APIS.ORDERS, query);
  }

  getSkippedOrders(query: Record<string, any>): Observable<any> {
    query['skipped'] = true;
    return this.httpService.getData(APIS.ORDERS, query);
  }

  createInspections(data: Record<string, any>): Observable<any> {
    return this.httpService.postData(APIS.ORDERS, data);
  }

  updateSkipReason(data: Record<string, any>): Observable<any> {
    return this.httpService.putData(APIS.ORDERS, data);
  }

}


